import { SearchEvaluationPage } from './SearchEvaluationPage'
import { createSearchEvaluationStore } from './store'

const store = createSearchEvaluationStore()

export default function Main() {
	return <SearchEvaluationPage store={store} />
}
